


































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import Ajax from "../../lib/ajax";
import CreateMembership from "./create-membership.vue";
import EditMembership from "./edit-membership.vue";
import membershipRecords from "./membershipRecord.vue";
import membershipDetail from './membership-detail.vue'
class PagemembershipRequest extends PageRequest {
  name: string;
  showOnHome: boolean;
}

@Component({
  components: { EditMembership, CreateMembership, membershipRecords,membershipDetail },
})
export default class memberships extends AbpBase {
  // 编辑按钮事件处理
  edit() {
    this.editModalShow = true;
  }
  //请求过滤参数
  pagerequest: PagemembershipRequest = new PagemembershipRequest();

  createModalShow: boolean = false;
  editModalShow: boolean = false;
  membershipId: number = null;
  recordShow: boolean = false;
  detailShow:boolean=false;
  membershipList: Array<any> = [
    {
      value: "true",
      label: "是",
    },
    {
      value: "false",
      label: "否",
    },
  ];

  get list() {
    return this.$store.state.membership.list;
  }
  get loading() {
    return this.$store.state.membership.loading;
  }
  create() {
    this.createModalShow = true;
  }
  openDetailModal(id) {
    this.membershipId = id;
    this.detailShow = true;
  }
    openModal(id) {
     this.membershipId = id;
    this.recordShow = true;
  }
  
  pageChange(page: number) {
    this.$store.commit("membership/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("membership/setPageSize", pagesize);
    this.getpage();
  }
  search() {
    this.$store.commit("membership/setCurrentPage", 1);
    this.getpage();
  }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    await this.$store.dispatch({
      type: "membership/getAll",
      data: this.pagerequest,
    });
  }
  get pageSize() {
    return this.$store.state.membership.pageSize;
  }
  get totalCount() {
    return this.$store.state.membership.totalCount;
  }
  get currentPage() {
    return this.$store.state.membership.currentPage;
  }
  updateDisplayOrder(row) {
    Ajax.put("/api/services/app/membership/UpdatemembershipDisplayOrder", {
      id: row.id,
      displayOrder: row.displayOrder,
    });
  }

  async changeActive(row, pass: boolean) {
    this.$store.commit("membership/changeLoading", true);
    await Ajax.put("/api/services/app/membership/UpdatemembershipActiveState", {
      id: row.id,
      isActive: pass,
    });
    await this.getpage();
    this.$store.commit("membership/changeLoading", false);
  }
  async changePreferential(row, pass: boolean) {
    this.$store.commit("membership/changeLoading", true);
    await Ajax.put(
      "/api/services/app/membership/UpdatemembershipPreferential",
      { id: row.id, isPreferential: pass }
    );
    await this.getpage();
    this.$store.commit("membership/changeLoading", false);
  }
  columns = [
     {
      title: "球场名称",
      width: 200,
      key: "name",
      tooltip: true,
        render: (h: any, params: any) => {
        return h("span", params.row.court.name);
      },
    },
    {
      title: "会籍名称",
      width: 200,
      key: "name",
      tooltip: true,
    },
    {
      title: "球会牌价",
      key: "price",
      render: (h: any, params: any) => {
        return h("span", params.row.price + "万元");
      },
    },
    {
      title: "转让费",
      key: "transferFee",
      render: (h: any, params: any) => {
        return h("span", params.row.transferFee);
      },
    },
    {
      title: "月费",
      key: "monthlyFee",
      render: (h: any, params: any) => {
        return h("span", params.row.monthlyFee + "元/年");
      },
    },
    {
      title: "是否首页显示",
      key: "showOnHome",
      render: (h: any, params: any) => {
        return h("span", params.row.showOnHome == true ? "是" : "否");
      },
    },
    {
      title: "位置",
      key: "position",
      tooltip: true,
      with:180
    },
    // {
    //   title: "球会简介",
    //   key: "description",
    //   tooltip: true,
    // },
    // {
    //   title: "使用流程",
    //   key: "flow",
    //   tooltip: true,
    // },
    {
      title: "显示顺序",
      key: "displayOrder",
      tooltip: true,
      width:70
    },
    {
      title: this.L("CreationTime"),
      key: "creationTime",
      render: (h: any, params: any) => {
        return h(
          "span",
          new Date(params.row.creationTime).toLocaleDateString()
        );
      },
    },
    {
      title: this.L("Actions"),
      key: "Actions",
      width: 200,
      align: "center",
      slot: "action",
      render: (h, params) => {
        const hasEditPermission = this.hasPermission("Pages.Membership.Edit");
        const hasDeletePermission = this.hasPermission(
          "Pages.Membership.Delete"
        );
        const hasViewPermission = this.hasPermission("Pages.Membership");

        const buttons = [];

        if (hasEditPermission) {
          buttons.push(
            h(
              "Button",
              {
                props: {
                  type: "primary",
                  size: "small",
                },
                style: {
                  marginRight: "5px",
                },
                on: {
                  click: () => {
                    this.membershipId = params.row.id;
                    this.$store.commit("membership/edit", params.row);
                    this.edit();
                  },
                },
              },
              "编辑"
            )
          );
        }

        if (hasDeletePermission) {
          buttons.push(
            h(
              "Button",
              {
                props: {
                  type: "error",
                  size: "small",
                },
                style: {
                  marginRight: "5px",
                },
                on: {
                  click: async () => {
                    this.$Modal.confirm({
                      title: "提示",
                      content: "确定要删除该会籍吗？",
                      okText: "是",
                      cancelText: "否",
                      onOk: async () => {
                        await this.$store.dispatch({
                          type: "membership/delete",
                          data: params.row,
                        });
                        await this.getpage();
                      },
                    });
                  },
                },
              },
              "删除"
            )
          );
        }

        if (hasViewPermission) {
          buttons.push(
            h(
              "Button",
              {
                props: {
                  type: "primary",
                  size: "small",
                },
                 style: {
                  marginRight: "5px",
                },
                on: {
                  click: async () => {
                    this.openModal(params.row.id);
                  },
                },
              },
              "查看"
            )
          );
        }
        if (hasViewPermission) {
          buttons.push(
            h(
              "Button",
              {
                props: {
                  type: "primary",
                  size: "small",
                },
                on: {
                  click: async () => {
                    this.openDetailModal(params.row.id);
                  },
                },
              },
              "详情"
            )
          );
        }
        return h("div", buttons);
      }
    }
  ];
  async created() {
    this.getpage();
  }
}
